import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { images } from '../../../Constants/ImageUrls';
import { removeDefaultParams } from '../../../Utils/helper';
import { fireClickedEvent } from '../instrumentation';
import { MobileCategoriesSec, ScrollableListSection } from './styled';

export default function MobileCategories(props) {
  const { tabsData, setClicked, _id, clicked } = props;
  const router = useRouter();

  return (
    <MobileCategoriesSec>
      <ScrollableListSection>
        {tabsData?.map((element, index) => {
          return (
            <Link
              href={{
                pathname: element?.key,
                query: removeDefaultParams(router.query),
              }}
              passHref
              key={`sideCategory${index}`}
              locale={false}
              className={element?.isSelected ? 'selectedBorder' : null}
              onClick={() => {
                setClicked(true);
                fireClickedEvent(element?._id, element?.tabName);
              }}
            >
              <Image
                src={
                  element?.mobileWebIcon ||
                  element?.smart_icon ||
                  images.defaultCategory
                }
                className="image"
                alt={element?.tabName}
                quality={90}
                title={element?.tabName}
                priority={true}
                fill
                sizes="20vw"
              />
              <p>{element?.tabName}</p>
            </Link>
          );
        })}
      </ScrollableListSection>
    </MobileCategoriesSec>
  );
}
